// Default state for the `exportLayers` map controlling which layers are included in PDF/Word export.
// Each value is an object so individual layers can be extended with extra fields later (color, opacity, etc.)
// without changing this shape.
export const DEFAULT_EXPORT_LAYERS = {
  // COVER PAGES
  'cover-page': { enabled: false },
  'cover-back-page': { enabled: false },

  // MODERN VASTU SECTION
  'floor-plan': { enabled: false },
  'grid-layout': { enabled: false },
  'center-analysis': { enabled: false },
  'mahavastu-chakra': { enabled: false },
  'Vedic-Mahavastu-Chakra': { enabled: false },
  'shakti-chakra': { enabled: false },
  'floor-plan-vpm': { enabled: false },

  // 8 ZONES
  'compass-8': { enabled: false },
  'Bar-chart-8': { enabled: false },

  // 16 ZONES
  'compass-16': { enabled: false },
  'Bar-chart-16': { enabled: false },

  // 24 ZONES
  'compass-24': { enabled: false },
  'surya-chandra-bhag': { enabled: false },
  '4-state-image': { enabled: false },
  'tri-dosh-Vedic': { enabled: false },
  'tri-guna-modern': { enabled: false },
  'tri-guna-Vedic': { enabled: false },
  'tri-dosh-modern': { enabled: false },
  'body-part-division': { enabled: false },

  // 32 MAHAVASTU ZONES
  'compass-32': { enabled: false },
  'Bar-chart-32': { enabled: false },

  // 45 Devata (MODERN)
  'compass-45-2': { enabled: false },
  'compass-45-2-table': { enabled: false },
  'compass-45-2-chart': { enabled: false },

  // COLOURED ZONE & ELEMENTAL
  'coloured-zone': { enabled: false },
  'elemental-5-zone': { enabled: false },
  'elemental-5-chart': { enabled: false },

  // MARMSTHAN
  'marmsthan-analysis': { enabled: false },
  'marmsthan-advance': { enabled: false },

  // VASTU NUMBERS
  'vastu-numbers-81-numbers': { enabled: false },
  'vastu-numbers-81-numbers-Vedic': { enabled: false },
  'vastu-numbers-64': { enabled: false },

  // 3X3 GRID
  'grid-3x3': { enabled: false },

  // 32 ENTRANCE ANALYSIS COMPASS
  '32-Entrance-Analysis-Compass': { enabled: false },

  // IMAGES
  'png-image-1': { enabled: false },
  'Khanija-Dhatu': { enabled: false },
  '16-Directional-Domestic-Vastu': { enabled: false },
  'Direction-Diety-Planet': { enabled: false },
  'Devata-Khanij': { enabled: false },
  'Devata-Bhojan': { enabled: false },
  'Devata-Bhojan-aadi': { enabled: false },
  'Devata-chinha': { enabled: false },
  'Devata-chinha-aadi': { enabled: false },
  'Muhurat-vichar': { enabled: false },
  'Seharumkh-achintya-vibhav': { enabled: false },
  'png-image-2': { enabled: false },
  'Vedic-devata-Numbers-with-Names-81': { enabled: false },
  'Disha-Gandha': { enabled: false },
  'Devata-Nighat': { enabled: false },
  'Nighantu': { enabled: false },

  'MANDAL': { enabled: false },
  'RATNA-STHAPNA': { enabled: false },
  'nakshatra-vastu': { enabled: false },
  'Devata-Nakshatra-Vastu': { enabled: false },

  // VEDIC GENERATIVE ZONES (computed diagrams, not static images)
  'Vedic-zones-32': { enabled: false },
  'Vedic-numbers-64': { enabled: false },
  'Vedic-64-padvinyash': { enabled: false },
  'Vedic-81-padvinyash': { enabled: false },
  'Vedic-elemental-zone': { enabled: false },
  'Vedic-planet-zoning': { enabled: false },

  // HOUSE PLANNING GUIDE
  'house-bank': { enabled: false },
  'house-clinic': { enabled: false },
  'house-electronic-shop': { enabled: false },
  'house-factory': { enabled: false },
  'house-hotel': { enabled: false },
  'house-marriage-hall': { enabled: false },
  'house-multiplex': { enabled: false },
  'house-office-cabin': { enabled: false },
  'house-petrol-pump': { enabled: false },
  'house-retail-outlets': { enabled: false },
  'house-school-college': { enabled: false },
  'house-space-analysis-compass': { enabled: false },
  'house-temple': { enabled: false },

  // REPORTS (LAST)
  'entrance-analysis-report':   { enabled: false },
  'space-analysis-report':      { enabled: false },
  'vastu-devta-guide-report':   { enabled: false },
  'navgrah-shanti-report':      { enabled: false },
  'feng-shui-report':           { enabled: false },
  'helix-report':               { enabled: false },
  'zone-analysis-report':       { enabled: false },
  'numero-vastu-report':        { enabled: false },
  'astro-vastu-report':         { enabled: false },
  'cut-zone-report':            { enabled: false },
  'extension-zone-report':      { enabled: false },
};
